import { render, staticRenderFns } from "./cookie-popup.vue?vue&type=template&id=38f566e2&"
import script from "./cookie-popup.vue?vue&type=script&lang=js&"
export * from "./cookie-popup.vue?vue&type=script&lang=js&"
import style0 from "./cookie-popup.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports